<template>
  <div>
    <div>
      <div class="form-group">
        <div class="admin-section">
          <div v-on:click="toggleLogin">
            <h3 class="admin-btn">Login</h3>
          </div>

          <login-form v-if="showLogin"></login-form>
        </div>

        <div class="admin-section">
          <div v-on:click="toggleRegister">
            <h3 class="admin-btn">Register</h3>
          </div>

          <register-form v-if="showRegister"></register-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { API_URL } from "../env.js";
import LoginForm from "./LoginForm.vue";
import RegisterForm from "./RegisterForm.vue";

export default {
  data() {
    return {
      showForgotPassword: false,
      showRegister: false,
      showLogin: true
    };
  },

  components: {
    "login-form": LoginForm,
    "register-form": RegisterForm
  },

  computed: {
    user: function() {
      return this.$store.state.notes.user;
    }
  },

  methods: {
    toggleRegister() {
      this.showRegister = !this.showRegister;
      this.showLogin = false;
    },

    toggleLogin() {
      this.showLogin = !this.showLogin;
      this.showRegister = false;
    }
  }
};
</script>
